import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const StyledDiv = styled.div`
  &&& {
    width: 100%;
    margin-bottom: 20px;

    li {
      display: inline-block;
      width: 30.3%;
      height: 52px;
      line-height: 52px;
      background-color: #f6f3f2;
      color: #000;
      font-size: 16px;
      font-weight: bold;
      text-align: center;
      position: relative;
      margin: 0 34px 0 0;
    }

    li:after {
      left: 100%;
      top: 50%;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      z-index: 20;
      border-left-color: #f6f3f2;
      border-width: 26px;
      margin-top: -26px;
    }

    li.active {
      background-color: #00aad2;
      color: #fff;
    }

    li.active:after {
      border-left-color: #00aad2;
    }

    li:last-child {
      margin-right: 26px;
    }
  }
`;

const ProgressWrapDiv = ({ children }) => {
  return (
    <StyledDiv>
      <ul>{children}</ul>
    </StyledDiv>
  );
};

export default ProgressWrapDiv;
